<template>
  <div class="about-us">
    <section-header tag="h1" class="mt-5 mb-5" title="關於我們" subtitle="About Loft29"/>
    <section class="pb-5 like-journal-detail-content">
      <p>「設計居家提案 塑造生活美學」</p>
      <p>居家風格是由生活態度與品味美感堆砌而來，而家具除了帶來舒適便利性，同時也是乘載家人共同記憶的美好物件</p>
      <p>Loft29 collection成立於 2008 年，擁有近 20 年代理進口家具的專業經驗，蒐羅來自全球數十個設計家具、家飾品牌。我們目標是為熱愛生活、重視家居品質的您，提供多面向的生活提案以及優質的選品空間；透過每件家具、每盞燈飾的獨特價值，傳遞設計師對於設計與生活的專注熱情</p>
    </section>
  </div>
</template>

<script>
import SectionHeader from '@/components/SectionHeader.vue'
export default {
  name: 'AboutUs',
  components: {
    SectionHeader
  }
}
</script>

<style scoped>
.like-journal-detail-content {
  font-size: 19px;
  font-weight: 400;
}
</style>
